<template>
  <div>
    <p class="filter-tit">
      {{ fieldname }}
    </p>
    <div class="area-item">
      <!-- <input
        read-only
        :value="value"
        style="width: 280px;"
        type="hidden"
        @focus="focusHandle"
      > -->
      <input
        read-only
        :placeholder="`${enterPlaceholder}${fieldname}`"
        :value="showValue"
        class="input"
        @focus="focusHandle"
      >
      <!-- <span
        class="left"
        @click="focusHandle"
      >
        henan > zhengzh > jinshui
      </span> -->
      <i class="iconfont icon-angle-right iconicon-test18" />
    </div>
    <!-- <linkage
      :default-value="newValue"
      :visible.sync="visible"
      :has-child="item => item.haschildren !== 0"
      :get-data="getData"
      :search-data="searchData"
      @change="changeHandle"
    /> -->
  </div>
</template>

<script>
import { getArea, SearchArea as searchArea, addAreaSearchLog } from '@/services'
import LinkagePicker from '@/components/mobile/Linkage'
import Vue from 'vue'
import { createAPI } from 'cube-ui'
createAPI(Vue, LinkagePicker, ['chang'], true)

export default {
  /* components: {
    Linkage
  }, */
  props: {
    data: {
      type: [Object, Array, String, Boolean],
      default () {
        return {}
      }
    },
    value: {
      type: [Object, Array],
      default: () => { }
    }
  },
  data () {
    const { value = {} } = this
    const arr = []
    Object.keys(value).forEach(code => {
      arr.push({
        code,
        name: value[code]
      })
    })
    return {
      newValue: arr,
      visible: false
    }
  },
  computed: {
    showValue () {
      return this.newValue.map(item => item.name).join(' / ')
    },
    fieldname () {
      return this.data.fieldname
    },
    enterPlaceholder () {
      return this.$t('message["751"]')
    }
  },
  methods: {
    async getData ({ level, data }) {
      const chain = await getArea()
      if (data) {
        chain.params({
          code: data.code
        })
      }
      return new Promise(async (resolve, reject) => {
        await chain
          .onSuccess(payload => {
            const arr = Object.keys(payload).map(key => payload[key])
            resolve(arr)
          })
          .onNetFail(err => {
            reject(err)
          })
          .fetch()
      })
    },
    async searchData ({ keyword }) {
      const chain = await searchArea()
      return new Promise(async (resolve, reject) => {
        await chain
          .params({
            keyword,
            fieldkey: 'company_address'
          })
          .onSuccess(payload => {
            const arr = payload.map(item => {
              return Object.keys(item).map(code => {
                return {
                  code,
                  name: item[code]
                }
              })
            })
            // const arr = Object.keys(payload).map(key => payload[key])
            resolve(arr)
          })
          .onNetFail(err => {
            reject(err)
          })
          .fetch()
      })
    },
    focusHandle () {
      // this.visible = true
      let instance = LinkagePicker.$create({
        $props: {
          defaultValue: this.newValue,
          hasChild: item => {
            return item.haschildren !== 0
          },
          getData: this.getData,
          searchData: this.searchData,
          reportSearch: this.reportSearch
        },
        $attrs: {
          ref: 'linkagePicker'
        },
        $class: {
          'linkagePicker': true
        },
        $events: {
          change: this.changeHandle,
          update: this.updateShow
        }
      })
      instance.show()
    },
    changeHandle (selected, hasChild) {
      if (!hasChild) {
        this.visible = false
      }
      this.newValue = selected
      const value = {}
      selected.forEach(item => {
        const { code, name } = item
        value[code] = name
      })
      this.$emit('change', value)
    },
    updateShow (visible) {
      this.visible = visible
    },
    async reportSearch (value) {
      const chain = await addAreaSearchLog()
      return new Promise(async (resolve, reject) => {
        await chain
          .params({
            name: value
          })
          .onSuccess(payload => {
            resolve(true)
          })
          .onNetFail(err => {
            reject(err)
          })
          .fetch()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.area-item {
  // border-bottom: 1px solid #dbdbdb;
  // border-top: 1px solid #dbdbdb;
  display: flex;
  justify-content: space-between;
  height: 56px;
  line-height: 56px;
  padding: 0 16px;
  color: #333;
  font-size: 16px;
  .iconicon-test18 {
    color: #d6d6d6;
  }
  .input {
    width: 100%;
    outline: none;
  }
}
</style>
